// Mock data for initial frontend development
// This will be replaced with IndexedDB data

import { v4 as uuidv4 } from 'uuid';

export const mockUsers = [
  {
    id: '1',
    email: 'admin@company.com',
    role: 'admin',
    profile: {
      firstName: 'System',
      lastName: 'Administrator',
      department: 'Management',
      position: 'Administrator',
      location: 'HQ',
      phone: '555-0100',
      gender: 'male',
      dateOfBirth: Date.now() - 30 * 365 * 24 * 60 * 60 * 1000,
      hireDate: Date.now() - 365 * 24 * 60 * 60 * 1000
    },
    status: 'active'
  },
  {
    id: '2',
    email: 'supervisor@company.com',
    role: 'supervisor',
    supervisorId: '1',
    profile: {
      firstName: 'Sarah',
      lastName: 'Johnson',
      department: 'Engineering',
      position: 'Team Lead',
      location: 'HQ',
      phone: '555-0101',
      gender: 'female',
      dateOfBirth: Date.now() - 35 * 365 * 24 * 60 * 60 * 1000,
      hireDate: Date.now() - 3 * 365 * 24 * 60 * 60 * 1000
    },
    status: 'active'
  },
  {
    id: '3',
    email: 'john.smith@company.com',
    role: 'employee',
    supervisorId: '2',
    profile: {
      firstName: 'John',
      lastName: 'Smith',
      department: 'Engineering',
      position: 'Software Developer',
      location: 'HQ',
      phone: '555-0102',
      gender: 'male',
      dateOfBirth: Date.now() - 28 * 365 * 24 * 60 * 60 * 1000,
      hireDate: Date.now() - 2 * 365 * 24 * 60 * 60 * 1000
    },
    status: 'active'
  },
  {
    id: '4',
    email: 'emily.davis@company.com',
    role: 'employee',
    supervisorId: '2',
    profile: {
      firstName: 'Emily',
      lastName: 'Davis',
      department: 'Marketing',
      position: 'Marketing Specialist',
      location: 'Remote',
      phone: '555-0103',
      gender: 'female',
      dateOfBirth: Date.now() - 32 * 365 * 24 * 60 * 60 * 1000,
      hireDate: Date.now() - 1.5 * 365 * 24 * 60 * 60 * 1000
    },
    status: 'active'
  },
  {
    id: '5',
    email: 'michael.brown@company.com',
    role: 'employee',
    supervisorId: '2',
    profile: {
      firstName: 'Michael',
      lastName: 'Brown',
      department: 'Engineering',
      position: 'Senior Developer',
      location: 'HQ',
      phone: '555-0104',
      gender: 'male',
      dateOfBirth: Date.now() - 38 * 365 * 24 * 60 * 60 * 1000,
      hireDate: Date.now() - 4 * 365 * 24 * 60 * 60 * 1000
    },
    status: 'active'
  }
];

export const mockAppraisals = [
  {
    id: uuidv4(),
    userId: '3',
    templateId: '1',
    title: 'Annual Performance Review 2025',
    type: 'annual',
    status: 'employee_completed',
    dueDate: Date.now() + 14 * 24 * 60 * 60 * 1000,
    createdAt: Date.now() - 30 * 24 * 60 * 60 * 1000,
    updatedAt: Date.now() - 2 * 24 * 60 * 60 * 1000,
    performanceAreas: [
      { competencyId: '1', competencyName: 'Communication', weight: 20, employeeScore: 4, employeeComment: 'I consistently communicate well with my team.', completedByEmployee: true, completedByManager: false },
      { competencyId: '2', competencyName: 'Problem Solving', weight: 20, employeeScore: 5, employeeComment: 'Solved complex technical issues this quarter.', completedByEmployee: true, completedByManager: false },
      { competencyId: '3', competencyName: 'Accountability', weight: 20, employeeScore: 4, completedByEmployee: true, completedByManager: false },
      { competencyId: '4', competencyName: 'Dependability', weight: 20, employeeScore: 4, completedByEmployee: true, completedByManager: false },
      { competencyId: '5', competencyName: 'Punctuality', weight: 20, employeeScore: 5, employeeComment: 'Always on time for meetings and deliverables.', completedByEmployee: true, completedByManager: false }
    ],
    goals: {
      current: [
        { id: uuidv4(), title: 'Complete React certification', description: 'Obtain advanced React certification', status: 'completed', priority: 'high', dueDate: Date.now() - 30 * 24 * 60 * 60 * 1000 },
        { id: uuidv4(), title: 'Lead code reviews', description: 'Conduct at least 5 code reviews per week', status: 'in_progress', priority: 'medium', dueDate: Date.now() + 60 * 24 * 60 * 60 * 1000 }
      ],
      future: [
        { id: uuidv4(), title: 'Mentor junior developers', description: 'Mentor 2 junior team members', status: 'not_started', priority: 'high', dueDate: Date.now() + 180 * 24 * 60 * 60 * 1000 }
      ],
      pdp: [
        { id: uuidv4(), type: 'training', description: 'AWS Solutions Architect course', justification: 'Required for cloud migration project' }
      ]
    },
    comments: {
      employee: 'This year has been productive. Looking forward to taking on more responsibilities.'
    },
    progress: {
      performanceAreasComplete: true,
      goalsComplete: true,
      commentsComplete: true,
      overallPercent: 100
    },
    scores: {
      employeeSelfTotal: 4.4
    }
  },
  {
    id: uuidv4(),
    userId: '4',
    templateId: '1',
    title: 'Annual Performance Review 2025',
    type: 'annual',
    status: 'ready_to_evaluate',
    dueDate: Date.now() + 21 * 24 * 60 * 60 * 1000,
    createdAt: Date.now() - 15 * 24 * 60 * 60 * 1000,
    updatedAt: Date.now() - 15 * 24 * 60 * 60 * 1000,
    performanceAreas: [
      { competencyId: '1', competencyName: 'Communication', weight: 20, completedByEmployee: false, completedByManager: false },
      { competencyId: '2', competencyName: 'Problem Solving', weight: 20, completedByEmployee: false, completedByManager: false },
      { competencyId: '3', competencyName: 'Accountability', weight: 20, completedByEmployee: false, completedByManager: false },
      { competencyId: '4', competencyName: 'Dependability', weight: 20, completedByEmployee: false, completedByManager: false },
      { competencyId: '5', competencyName: 'Punctuality', weight: 20, completedByEmployee: false, completedByManager: false }
    ],
    goals: { current: [], future: [], pdp: [] },
    comments: {},
    progress: { performanceAreasComplete: false, goalsComplete: false, commentsComplete: false, overallPercent: 0 },
    scores: {}
  },
  {
    id: uuidv4(),
    userId: '5',
    templateId: '1',
    title: 'Annual Performance Review 2025',
    type: 'annual',
    status: 'finalized',
    dueDate: Date.now() - 7 * 24 * 60 * 60 * 1000,
    createdAt: Date.now() - 60 * 24 * 60 * 60 * 1000,
    updatedAt: Date.now() - 7 * 24 * 60 * 60 * 1000,
    finalizedAt: Date.now() - 7 * 24 * 60 * 60 * 1000,
    performanceAreas: [
      { competencyId: '1', competencyName: 'Communication', weight: 20, employeeScore: 4, managerScore: 4, managerComment: 'Excellent communication skills.', completedByEmployee: true, completedByManager: true },
      { competencyId: '2', competencyName: 'Problem Solving', weight: 20, employeeScore: 4, managerScore: 5, managerComment: 'Outstanding problem-solving abilities.', completedByEmployee: true, completedByManager: true },
      { competencyId: '3', competencyName: 'Accountability', weight: 20, employeeScore: 4, managerScore: 4, completedByEmployee: true, completedByManager: true },
      { competencyId: '4', competencyName: 'Dependability', weight: 20, employeeScore: 5, managerScore: 5, managerComment: 'Very reliable team member.', completedByEmployee: true, completedByManager: true },
      { competencyId: '5', competencyName: 'Punctuality', weight: 20, employeeScore: 4, managerScore: 4, completedByEmployee: true, completedByManager: true }
    ],
    goals: {
      current: [
        { id: uuidv4(), title: 'Improve code coverage', description: 'Increase test coverage to 80%', status: 'completed', priority: 'high', dueDate: Date.now() - 30 * 24 * 60 * 60 * 1000 }
      ],
      future: [],
      pdp: []
    },
    comments: {
      employee: 'Great year of growth and learning.',
      manager: 'Michael has been a valuable team member. Excellent performance overall.'
    },
    progress: { performanceAreasComplete: true, goalsComplete: true, commentsComplete: true, overallPercent: 100 },
    scores: {
      employeeSelfTotal: 4.2,
      managerTotal: 4.4,
      finalWeightedScore: 4.4
    },
    signatures: {
      employee: { signed: true, timestamp: Date.now() - 8 * 24 * 60 * 60 * 1000 },
      manager: { signed: true, timestamp: Date.now() - 7 * 24 * 60 * 60 * 1000 }
    }
  }
];

export const mockTemplates = [
  {
    id: '1',
    name: 'Annual Performance Review',
    description: 'Standard annual performance evaluation',
    type: 'annual',
    sections: [
      {
        id: '1',
        name: 'Performance Areas',
        order: 1,
        competencies: [
          { id: '1', name: 'Communication', description: 'Ability to convey information clearly', weight: 20 },
          { id: '2', name: 'Problem Solving', description: 'Ability to identify and resolve issues', weight: 20 },
          { id: '3', name: 'Accountability', description: 'Takes ownership of responsibilities', weight: 20 },
          { id: '4', name: 'Dependability', description: 'Reliability and consistency', weight: 20 },
          { id: '5', name: 'Punctuality', description: 'Timeliness and attendance', weight: 20 }
        ]
      },
      { id: '2', name: 'Goals', order: 2 },
      { id: '3', name: 'Comments', order: 3 }
    ],
    createdAt: Date.now() - 365 * 24 * 60 * 60 * 1000
  },
  {
    id: '2',
    name: 'New Hire 30-Day Review',
    description: 'First month evaluation for new employees',
    type: 'introductory',
    sections: [
      {
        id: '1',
        name: 'Performance Areas',
        order: 1,
        competencies: [
          { id: '1', name: 'Learning & Adaptation', description: 'Ability to learn new processes', weight: 50 },
          { id: '2', name: 'Team Integration', description: 'Collaboration with team members', weight: 50 }
        ]
      }
    ],
    createdAt: Date.now() - 180 * 24 * 60 * 60 * 1000
  }
];

export const mockNotifications = [
  {
    id: uuidv4(),
    userId: '2',
    type: 'appraisal_submitted',
    title: 'Appraisal Submitted',
    message: 'John Smith has submitted their annual performance review.',
    link: '/supervisor/appraisals',
    read: false,
    actionRequired: true,
    priority: 'high',
    timestamp: Date.now() - 2 * 24 * 60 * 60 * 1000
  },
  {
    id: uuidv4(),
    userId: '2',
    type: 'appraisal_due',
    title: 'Appraisal Due Soon',
    message: 'Emily Davis has an appraisal due in 21 days.',
    link: '/supervisor/appraisals',
    read: true,
    actionRequired: false,
    priority: 'medium',
    timestamp: Date.now() - 5 * 24 * 60 * 60 * 1000
  },
  {
    id: uuidv4(),
    userId: '1',
    type: 'new_employee',
    title: 'New Employee Registered',
    message: 'A new employee has joined the platform via invite link.',
    link: '/admin/employees',
    read: false,
    actionRequired: false,
    priority: 'low',
    timestamp: Date.now() - 1 * 24 * 60 * 60 * 1000
  }
];

export const mockInvites = [
  {
    id: uuidv4(),
    inviteCode: 'INV-2025-001',
    role: 'employee',
    createdBy: '1',
    expiryDate: Date.now() + 30 * 24 * 60 * 60 * 1000,
    maxUses: 10,
    usedCount: 3,
    department: 'Engineering',
    status: 'active',
    createdAt: Date.now() - 7 * 24 * 60 * 60 * 1000
  },
  {
    id: uuidv4(),
    inviteCode: 'INV-2025-002',
    role: 'supervisor',
    createdBy: '1',
    expiryDate: Date.now() + 14 * 24 * 60 * 60 * 1000,
    maxUses: 5,
    usedCount: 1,
    department: 'Sales',
    status: 'active',
    createdAt: Date.now() - 3 * 24 * 60 * 60 * 1000
  }
];

export const mockCalendarEvents = [
  {
    id: uuidv4(),
    title: 'Performance Review Meeting',
    description: 'Quarterly performance review discussion',
    type: 'meeting',
    startDate: Date.now() + 3 * 24 * 60 * 60 * 1000,
    endDate: Date.now() + 3 * 24 * 60 * 60 * 1000 + 60 * 60 * 1000,
    allDay: false,
    participants: ['2', '3'],
    location: 'Conference Room A',
    createdBy: '2'
  },
  {
    id: uuidv4(),
    title: 'Appraisal Deadline',
    description: 'Annual appraisal submission deadline',
    type: 'deadline',
    startDate: Date.now() + 14 * 24 * 60 * 60 * 1000,
    endDate: Date.now() + 14 * 24 * 60 * 60 * 1000,
    allDay: true,
    participants: ['3', '4', '5'],
    createdBy: '1'
  }
];

export const mockFeedbackSnippets = [
  { id: uuidv4(), category: 'performance', sentiment: 'positive', text: 'Consistently exceeds expectations in delivering quality work.', tags: ['quality', 'excellence'] },
  { id: uuidv4(), category: 'performance', sentiment: 'improvement', text: 'Would benefit from additional training in this area.', tags: ['development', 'training'] },
  { id: uuidv4(), category: 'goals', sentiment: 'positive', text: 'Successfully achieved all set objectives ahead of schedule.', tags: ['goals', 'achievement'] },
  { id: uuidv4(), category: 'general', sentiment: 'positive', text: 'A valuable team member who consistently contributes to team success.', tags: ['teamwork', 'collaboration'] },
  { id: uuidv4(), category: 'general', sentiment: 'neutral', text: 'Meets the basic requirements of the role.', tags: ['baseline', 'adequate'] }
];

// Helper function to get user by ID
export const getUserById = (id) => mockUsers.find(u => u.id === id);

// Helper function to get appraisals for a user
export const getAppraisalsForUser = (userId) => mockAppraisals.filter(a => a.userId === userId);

// Helper function to get team members for supervisor
export const getTeamMembers = (supervisorId) => mockUsers.filter(u => u.supervisorId === supervisorId);
